<template>
  <div id="contenidor_appheader">
    <div id="top_info" class="w3-contanier w3-row" v-if="isAuthenticated">
      <div class="pageTitle">
        <transition name="fade" mode="out-in">
          <h1 id="titol_pagina" :key="contentName">{{ contentName }}</h1>
        </transition>
      </div>
      <div class="info">
        <div class="info-header">
          <div class="errors">
            <transition name="fade" mode="out-in">
              <span v-if="authStatus === '403'" class="formErrors">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error403') }}.
              </span>
              <span v-else-if="authStatus === '404'" class="formErrors">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error404') }}.
              </span>
              <span v-else-if="authStatus && authStatus !== '401' && authStatus !== 'success' && authStatus !== 'loading'" class="formErrors">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error500header') }}.
              </span>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <!-- SUBMENU OPTIONS -->
    <actions-header />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ActionsHeader from '@/components/appHeader/actionsHeader'
import * as authTypes from '@/store/actions/auth'
import { MLBuilder } from 'vue-multilanguage'

export default {
  name: 'app-header',
  data () {
    return {
    }
  },
  components: {
    ActionsHeader
  },
  methods: {
  },
  computed: {
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [`${authTypes.AUTH_AUTHENTICATED}`, `${authTypes.AUTH_STATUS}`]),
    ...mapState({
      authLoading: state => state.auth.status === 'loading',
      gender: state => `${state.user.gender}`,
      name: state => `${state.user.name}`,
      contentName (state) {
        var result = ''
        if (state.app.currentContent.name) {
          result = `${state.app.currentContent.name}`
        }
        return result
      },
      mlmyMessage (state) {
        return new MLBuilder('welcome' + state.user.gender).with('name', state.user.name)
      }
    })
  },
  filters: {
    lletraUsuari (value) {
      return value.substring(0, 1).toUpperCase()
    }
  }
}
</script>

<style lang="scss">
#content #contenidor_appheader {
  z-index: 999;
  padding: 0 12px;
  background-color: #f9f9f9;
  border-bottom: 1px dotted #bbb;

  #top_info {
    display: none;
    height: 90px;

    .pageTitle {
      float: left;

      #titol_pagina {
        font-family: "Source Sans Pro", sans-serif;
        font-size: 24px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #000;
        margin-top: 30px;
      }
    }

    .info {
      float: right;

      .info-header {
        padding-top: 15px;

        .errors {
          float: right;
          margin-right: 30px;

          .formErrors {
            margin-top: 0;
          }
        }
      }
    }
  }
}
.home #content #contenidor_appheader {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/appHeader/index.vue